module.exports = __webpack_public_path__ + "static/img/2.AI工作助理_悬浮窗_image@2x.8e1d3d2d.png";